import { CdnAsset } from "#components/ui/CdnAsset.tsx";
import { SourcePreview } from "#features/conversations/components/conversation-source/source-preview/SourcePreview.tsx";
import type { SourcePreviewProps } from "#features/conversations/components/conversation-source/source-preview/SourcePreviewProps.ts";
import { useConversationSource } from "#features/conversations/hooks/useConversationSource.ts";
import { useFileMetadata } from "#features/conversations/hooks/useFileMetadata.ts";
import type { WorkleapFileLibraryFileCustomProperties } from "#types/types.ts";

export const FilePreview = ({ source }: SourcePreviewProps) => {
    const { author, date, description, title } = useConversationSource(source);
    const { getFileTypeIcon, getFileExtension } = useFileMetadata();
    const { fileName } = source.customProperties as WorkleapFileLibraryFileCustomProperties;

    return (
        <SourcePreview
            source={source}
            title={title}
            titleIcon={<CdnAsset asset={getFileTypeIcon(fileName)} alt={getFileExtension(fileName)} />}
            author={author}
            date={date}
            description={description}
        />
    );
};
